import {
  type CreateMealPlanRequest,
  type MealPlanDetail,
  MealPlanDetailSchema,
  type MealPlanListQuery,
  type MealPlanListResponse,
  MealPlanListResponseSchema,
  type UpdateMealPlanRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/** Meal Plan master API. Every response is validated with the shared Zod schema. */

export const listMealPlans = async (query: MealPlanListQuery): Promise<MealPlanListResponse> => {
  const { data } = await apiClient.get<unknown>('/meal-plans', { params: query });
  return MealPlanListResponseSchema.parse(data);
};

export const getMealPlan = async (id: string): Promise<MealPlanDetail> => {
  const { data } = await apiClient.get<unknown>(`/meal-plans/${id}`);
  return MealPlanDetailSchema.parse(data);
};

export const createMealPlan = async (payload: CreateMealPlanRequest): Promise<MealPlanDetail> => {
  const { data } = await apiClient.post<unknown>('/meal-plans', payload);
  return MealPlanDetailSchema.parse(data);
};

export const updateMealPlan = async (
  id: string,
  payload: UpdateMealPlanRequest,
): Promise<MealPlanDetail> => {
  const { data } = await apiClient.patch<unknown>(`/meal-plans/${id}`, payload);
  return MealPlanDetailSchema.parse(data);
};

export const deleteMealPlan = async (id: string): Promise<void> => {
  await apiClient.delete(`/meal-plans/${id}`);
};

export const bulkDeleteMealPlans = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/meal-plans/bulk-delete', { ids });
  return data;
};

export const bulkSetMealPlansStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/meal-plans/bulk-set-status', { ids, isActive });
  return data;
};
